import {
  ComponentConfig,
  ComponentType,
  FlexDirection,
  LayoutTypes,
} from "../services/types/ComponentTypes";
import {
  extractSummaryListFromConfig,
  resolveScreenConfigForHub,
} from "./billAllocationScreenConfig";

export type BillReleaseTab = "customer" | "vendor";

export type BillReleaseDocFilter =
  | "all"
  | "sales_invoice"
  | "purchase_bill"
  | "receipt_voucher"
  | "payment_voucher"
  | "credit_note"
  | "debit_note"
  | "journal_voucher"
  | "customer_advance"
  | "vendor_advance";

const BILL_RELEASE_TABS: ComponentConfig = {
  componentType: ComponentType.CUSTOM,
  customType: "billReleaseTabs",
} as ComponentConfig;

const SUMMARY_GROUP_STYLE = {
  backgroundColor: "#ffffff",
  direction: FlexDirection.COLUMN,
  borderRadius: 12,
  padding: 16,
};

const FAB_BY_TAB: Record<
  BillReleaseTab,
  { type: string; screenId: string; action: string }
> = {
  customer: {
    type: "add",
    screenId: "190",
    action: "navigate_modulev1/bill_wise_release",
  },
  vendor: {
    type: "add",
    screenId: "195",
    action: "navigate_modulev1/vendor_bill_wise_release",
  },
};

export { resolveScreenConfigForHub };

const applyDocumentFilterToSummary = (
  summaryList: ComponentConfig | null,
  docFilter: BillReleaseDocFilter
): ComponentConfig | null => {
  if (!summaryList || docFilter === "all") return summaryList;
  const cloned = JSON.parse(JSON.stringify(summaryList)) as any;
  if (cloned?.Form) {
    cloned.Form.Filter = `document_type = '${docFilter}'`;
  }
  return cloned as ComponentConfig;
};

export function patchBillReleaseHubScreenConfig(
  components: ComponentConfig[],
  options: {
    activeTab: BillReleaseTab;
    activeDocFilter?: BillReleaseDocFilter;
    customerConfig: ComponentConfig[] | null;
    vendorConfig: ComponentConfig[] | null;
  }
): ComponentConfig[] {
  const { activeTab, activeDocFilter = "all", customerConfig, vendorConfig } =
    options;
  const root = components[0] as any;
  if (!root) return components;

  const sourceConfig = activeTab === "vendor" ? vendorConfig : customerConfig;
  const summaryList = applyDocumentFilterToSummary(
    extractSummaryListFromConfig(sourceConfig),
    activeDocFilter
  );

  const nextRoot: any = {
    ...root,
    fabAction: FAB_BY_TAB[activeTab],
    childComponents: [
      BILL_RELEASE_TABS,
      {
        componentType: LayoutTypes.GROUP,
        style: SUMMARY_GROUP_STYLE,
        childComponents: summaryList ? [summaryList] : [],
      },
    ],
  };

  return [nextRoot as ComponentConfig];
}

export function normalizeBillReleaseTab(value: unknown): BillReleaseTab {
  return String(value ?? "").toLowerCase() === "vendor" ? "vendor" : "customer";
}
